module.exports = __webpack_public_path__ + "img/tab2.d2c3e085.png";